import { useEffect, useState } from "react";
import { Megaphone, X } from "lucide-react";
import { useSiteStatus } from "@/context/SiteStatusContext";
import "@/components/site-status.css";

export function AnnouncementBannerView({ banner, onClose, preview = false }) {
  if (!banner?.enabled || !banner.text?.trim()) return null;
  const isMarquee = banner.style === "marquee";
  const speed = Math.max(8, Number(banner.speed) || 30);
  return (
    <div className={`ab-root ab-${banner.theme || "blue"} ${preview ? "rounded-xl" : "ab-enter"}`} role="status" data-testid={preview ? "announcement-preview" : "announcement-banner"}>
      <div className="ab-shine" />
      <div className="ab-inner">
        <span className="ab-icon"><Megaphone className="h-3.5 w-3.5" /></span>
        {isMarquee ? (
          <div className="ab-track">
            <div className="ab-marquee" style={{ animationDuration: `${speed}s` }}>
              {[0, 1, 2, 3].map((i) => <span key={i}>{banner.text}</span>)}
            </div>
          </div>
        ) : (
          <p className="ab-glow" data-testid="announcement-text">{banner.text}</p>
        )}
        {banner.link_url && banner.link_label && (
          <a href={banner.link_url} className="ab-link" target={banner.link_url.startsWith("http") ? "_blank" : undefined} rel="noreferrer" data-testid="announcement-link">
            {banner.link_label}
          </a>
        )}
        {banner.closable && onClose && (
          <button type="button" onClick={onClose} className="ab-close" aria-label="Fermer" data-testid="announcement-close">
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
    </div>
  );
}

export default function AnnouncementBanner() {
  const { banner } = useSiteStatus();
  const [closedAt, setClosedAt] = useState("");
  useEffect(() => { setClosedAt(sessionStorage.getItem("ismotech_banner_closed") || ""); }, []);
  if (!banner?.enabled) return null;
  if (closedAt && closedAt === (banner.updated_at || "x")) return null;
  const close = () => {
    const key = banner.updated_at || "x";
    sessionStorage.setItem("ismotech_banner_closed", key);
    setClosedAt(key);
  };
  return <AnnouncementBannerView banner={banner} onClose={close} />;
}
